import { jsx as _jsx } from "react/jsx-runtime";
import { useScaleChecked } from '../../context/ScaleContext';
function StringNode({ signal, startY, levelHeight, fontSize, showLabels, }) {
    const { scaleX } = useScaleChecked();
    return (_jsx("text", { textAnchor: "middle", x: scaleX()(signal.delta), y: startY + levelHeight / 2, fontSize: fontSize, lengthAdjust: "spacing", fill: "black", visibility: showLabels ? 'visible' : 'hidden', children: signal.multiplicity }, `multiplicityString_${signal.id}`));
}
export default StringNode;
